import React, { useRef, useState } from 'react'

import InputText from '../input-text/input-text'
import * as CnpjUtility from '@components/utilities/cnpj-utility'
import inputProptypes from '../input-proptype'

import { useInitialValueToValidation } from '../custom-hooks'
import * as BaseFunctions from '../base-functions'
import useEvents from '@components/utilities/event-hooks-utility'

const InputCNPJ = ({ onChange, onBlur, errorMessage, value, name, required, ...rest }) => {
  const [currentMessage, setCurrentMessage] = useState(errorMessage)
  const [inputValue, setInputValue] = useState(value || '')
  const [currentName] = useState(BaseFunctions.getInputName(name))

  const thisInput = useRef(null)
  const defaultEvents = useEvents(thisInput)

  const validateCNPJ = (maskedCnpj, unmaskedCnpj) => {
    setCurrentMessage('')
    if (!required && !unmaskedCnpj.length) return
    if (maskedCnpj.length !== 18) return setCurrentMessage('CNPJ incompleto.')

    const isCnpjValid = CnpjUtility.validateCNPJ(unmaskedCnpj)
    if (!isCnpjValid) setCurrentMessage('CNPJ inválido.')
  }

  const handleOnChange = defaultEvents.useOnChange(async ({ value, id, name }) => {
    const { maskedCnpj, unmaskedCnpj } = CnpjUtility.maskCNPJ(value)

    setInputValue(maskedCnpj)

    if (onChange) await onChange({ value: unmaskedCnpj, maskedValue: maskedCnpj, id, name })

    return maskedCnpj
  })

  const handleOnBlur = value => {
    const { maskedCnpj, unmaskedCnpj } = CnpjUtility.maskCNPJ(value)

    validateCNPJ(maskedCnpj, unmaskedCnpj)
    if (onBlur) onBlur(unmaskedCnpj, maskedCnpj)
  }

  const inputProps = {
    type: 'tel',
    onChange: handleOnChange,
    onBlur: handleOnBlur,
    errorMessage: currentMessage,
    maxLength: 18,
    value: inputValue,
    name: currentName,
    onKeyUp: defaultEvents.onKeyUp,
    inputRef: thisInput,
    required,
    ...rest,
  }

  useInitialValueToValidation(value, () => {
    if (!value) return

    const { maskedCnpj, unmaskedCnpj } = CnpjUtility.maskCNPJ(value)
    setInputValue(maskedCnpj)
    validateCNPJ(maskedCnpj, unmaskedCnpj)
  })

  return <InputText {...inputProps} />
}

InputCNPJ.propTypes = inputProptypes

export default InputCNPJ
